import axios from "axios";

/*
 * Print Notes talks to the v2 gateway (hub-api-gateway), which hosts the
 * FHIR-mirror + current-medications + surgical-history-proprietary endpoints
 * this module needs. The host hub app's own `api` client points at the v1
 * gateway (`/ag`), whose legacy_mirror.py does NOT have those routes — so
 * Print Notes uses its own v2 client. The login token cross-validates on v2
 * (both gateways share SECRET_KEY + HS256 and the per-practice DB routing).
 *
 * Like the app's api.js, the response interceptor returns `response.data`
 * (the JSON body) so encounterData/PrintNotes see the same shape.
 */
const api = axios.create({
  baseURL: "/v2/ag",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
);

export default api;
